const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const AT = require("../vault/ActionTypes");
const {atTimeTracking} = require("../vault/StateCursors");
const OpsTimer = require("../vault/OpsTimer");
const DerivedBackend = require("../vault/DerivedBackend");
const ActivityAux = require("../../../shared/ActivityAux");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");

const styles = require("./styles/DevPanels.css");

/**
 * Dev panel that shows info about the current status of the time tracking,
 * mostly the current activity object and a live-updating timer.
 */

const getTimerMs = function(props) {
	const {tt} = props;
	return tt.timer ? OpsTimer.getAmountMsForNow(tt.timer, Date.now()) : 0;
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, function(props, vaultState) {
		return {
			idle: vaultState.idle,
			tt: atTimeTracking(vaultState).get(),
		};
	});
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "DevTimeTracking",

		propTypes: {
			// Injected by HOCs
			dispatch: PT.func.isRequired,
			idle: PT.bool,
			tt: PT.object,
		},

		statics: {
			getDerivedStateFromProps: function(props) {
				return {
					timerMs: getTimerMs(props),
				};
			},
		},

		getInitialState: function() {
			return {
				timerMs: getTimerMs(this.props),
			};
		},

		componentDidMount: function() {
			this.updateMsInterval = setInterval(() => {
				if (this.unmounted) return;
				this.setState({
					timerMs: getTimerMs(this.props),
				});
			}, 100);
		},

		componentWillUnmount: function() {
			this.unmounted = true;
			clearInterval(this.updateMsInterval);
		},

		getTimerMs: function(props) {
			const {tt} = props || this.props;
			return tt.timer ? OpsTimer.getAmountMsForNow(tt.timer, Date.now()) : 0;
		},

		onDebugIncrementTime: function(amountMs = 60000) {
			this.props.dispatch({
				type: AT.DEBUG_INCREMENT_TIME,
				amountMs,
			});
		},

		onDebugSaveTimeNow: function() {
			this.props.dispatch({
				type: AT.DEBUG_SAVE_TIME_NOW,
			});
		},

		renderActivity: function(act, idle) {
			if (!act && idle) {
				return "(idle)";
			} else if (!act) {
				return "(none)";
			}
			const auxKeys = ActivityAux.getOneActivityAuxKeys(act);

			const lines = [];

			lines.push(<div key={0}>{act.section + "." + act.subsection}</div>);
			if (act.type) {
				lines.push(<div key={1}>(type {act.type})</div>);
			}
			if (act.objectID && act.subobjectID) {
				lines.push(
					<div key={2}>
						id {act.objectID}-{act.subobjectID}
					</div>
				);
			} else if (act.objectID) {
				lines.push(<div key={2}>id {act.objectID}</div>);
			} else if (act.subobjectID) {
				lines.push(<div key={2}>id ?-{act.subobjectID}</div>);
			}
			if (auxKeys.length) {
				const auxStr = auxKeys.map(k => k[0]).join(", ");
				lines.push(<div key={3}>Aux: {auxStr}</div>);
			}
			return <div style={{maxWidth: "180px"}}>{lines}</div>;
		},

		render: function() {
			const {tt, idle} = this.props;
			const act = tt && tt.nowActivity;
			const displayedTime = DerivedBackend.msToNearestTenthSeconds(
				this.state.timerMs
			).toFixed(1);

			const timeDiv = act ? (
				<div>
					<strong>Time</strong>: {displayedTime}
				</div>
			) : null;
			const buttonIncDiv = act ? (
				<div>
					<button
						onClick={() => this.onDebugIncrementTime()}
						className={styles.button}
					>
						Add 1 minute
					</button>
				</div>
			) : null;
			const buttonNowDiv = (
				<div>
					<button
						onClick={() => this.onDebugSaveTimeNow()}
						className={styles.button}
					>
						Save to server now
					</button>
				</div>
			);

			return (
				<div>
					<div>
						<strong>Current Activity</strong>
					</div>
					{this.renderActivity(act, idle)}
					{timeDiv}
					{buttonIncDiv}
					{buttonNowDiv}
				</div>
			);
		},
	})
);
